<template>
    <v-form @submit.prevent="$emit('submit')">
        <v-alert
            v-model="error"
            type="error"
            border="left"
            dense
            colored-border
            dismissible
            transition="slide-y-transition"
        >
            Data yang kamu masukan salah, coba lagi
        </v-alert>
        <v-text-field
            v-model="credential"
            autofocus
            label="Username / E-mail"
            prepend-icon="mdi-account"
        ></v-text-field>
        <v-text-field
            type="password"
            v-model="loginPassword"
            label="Password"
            prepend-icon="mdi-lock"
        ></v-text-field>
        <v-btn
            type="submit"
            block
            large
            color="primary"
            :loading="$store.get('loader/loading', 'login')"
        >
            Masuk
        </v-btn>
    </v-form>
</template>

<script>
import { sync } from 'vuex-pathify'

export default {
    computed: sync('home', ['credential', 'loginPassword', 'error'])
}
</script>
